import { render } from "./addOrderPushObjDialog.vue?vue&type=template&id=1dbacc2a&scoped=true"
import script from "./addOrderPushObjDialog.vue?vue&type=script&lang=js"
export * from "./addOrderPushObjDialog.vue?vue&type=script&lang=js"

import "./addOrderPushObjDialog.vue?vue&type=style&index=0&id=1dbacc2a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbacc2a"]])

export default __exports__